// extracted by mini-css-extract-plugin
export default {"container":"container___NJjKB","title":"title___dBI8m"};